import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Beranda',
    component: () => import('../../components/views/Publik/Beranda.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Login',
    name: 'Login',
    component: () => import('../../components/views/Publik/Login.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/KontakKami',
    name: 'KontakKami',
    component: () => import('../../components/views/Publik/KontakKami.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarProgramBudgeting',
    name: 'DaftarProgramBudgeting',
    component: () => import('../../components/views/Publik/DaftarProgramBudgeting.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarFinance',
    name: 'DaftarFinance',
    component: () => import('../../components/views/Publik/DaftarFinance.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarMonev',
    name: 'DaftarMonev',
    component: () => import('../../components/views/Publik/DaftarMonev.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Dashboard',
    name: 'Dashboard',
    component: () => import('../../components/views/Dashboard/Dashboard.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Regulasi',
    name: 'Regulasi',
    component: () => import('../../components/views/Backoffice/Regulasi/Regulasi.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesRegulasi/:id',
    name: 'ProsesRegulasi',
    component: () => import('../../components/views/Backoffice/Regulasi/ProsesRegulasi.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarRegulasi',
    name: 'DaftarRegulasi',
    component: () => import('../../components/views/Publik/DaftarRegulasi.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Slider',
    name: 'Slider',
    component: () => import('../../components/views/Backoffice/Slider/Slider.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesSlider/:id',
    name: 'ProsesSlider',
    component: () => import('../../components/views/Backoffice/Slider/ProsesSlider.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Kategori',
    name: 'Kategori',
    component: () => import('../../components/views/Backoffice/Kategori/Kategori.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesKategori/:id',
    name: 'ProsesKategori',
    component: () => import('../../components/views/Backoffice/Kategori/ProsesKategori.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/SubKategori',
    name: 'SubKategori',
    component: () => import('../../components/views/Backoffice/SubKategori/SubKategori.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesSubKategori/:id',
    name: 'ProsesSubKategori',
    component: () => import('../../components/views/Backoffice/SubKategori/ProsesSubKategori.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/UnitKategori',
    name: 'UnitKategori',
    component: () => import('../../components/views/Backoffice/UnitKategori/UnitKategori.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesUnitKategori/:id',
    name: 'ProsesUnitKategori',
    component: () => import('../../components/views/Backoffice/UnitKategori/ProsesUnitKategori.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/InfoBeranda',
    name: 'InfoBeranda',
    component: () => import('../../components/views/Backoffice/InfoBeranda/InfoBeranda.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesInfoBeranda/:id',
    name: 'ProsesInfoBeranda',
    component: () => import('../../components/views/Backoffice/InfoBeranda/ProsesInfoBeranda.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Konten',
    name: 'Konten',
    component: () => import('../../components/views/Backoffice/Konten/Konten.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesKonten/:id',
    name: 'ProsesKonten',
    component: () => import('../../components/views/Backoffice/Konten/ProsesKonten.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/User',
    name: 'User',
    component: () => import('../../components/views/Backoffice/User/User.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesUser/:id',
    name: 'ProsesUser',
    component: () => import('../../components/views/Backoffice/User/ProsesUser.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Monev',
    name: 'Monev',
    component: () => import('../../components/views/Backoffice/Monev/Monev.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/IPP',
    name: 'IPP',
    component: () => import('../../components/views/Backoffice/IPP/IPP.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/GAP',
    name: 'GAP',
    component: () => import('../../components/views/Backoffice/GAP/GAP.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ImportExcel',
    name: 'ImportExcel',
    component: () => import('../../components/views/ImportExcel/ImportExcel.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/CEMP',
    name: 'CEMP',
    component: () => import('../../components/views/Backoffice/CEMP/CEMP.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/RKLRPL',
    name: 'RKLRPL',
    component: () => import('../../components/views/Backoffice/RKLRPL/RKLRPL.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Sampel',
    name: 'Sampel',
    component: () => import('../../components/views/Backoffice/Sampel/Sampel.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/KategoriData',
    name: 'KategoriData',
    component: () => import('../../components/views/Backoffice/KategoriData/KategoriData.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesKategoriData/:id',
    name: 'ProsesKategoriData',
    component: () => import('../../components/views/Backoffice/KategoriData/ProsesKategoriData.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/LayerPeta',
    name: 'LayerPeta',
    component: () => import('../../components/views/Backoffice/LayerPeta/LayerPeta.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesLayerPeta/:id',
    name: 'ProsesLayerPeta',
    component: () => import('../../components/views/Backoffice/LayerPeta/ProsesLayerPeta.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/GIS/:id',
    name: 'GIS',
    component: () => import('../../components/views/Publik/GIS.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarKonten/:id',
    name: 'DaftarKonten',
    component: () => import('../../components/views/Publik/DaftarKonten.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarKegiatan',
    name: 'DaftarKegiatan',
    component: () => import('../../components/views/Publik/DaftarKegiatan.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Berita',
    name: 'Berita',
    component: () => import('../../components/views/Backoffice/Berita/Berita.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesBerita/:id',
    name: 'ProsesBerita',
    component: () => import('../../components/views/Backoffice/Berita/ProsesBerita.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarBerita',
    name: 'DaftarBerita',
    component: () => import('../../components/views/Publik/DaftarBerita.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Galeri',
    name: 'Galeri',
    component: () => import('../../components/views/Backoffice/Galeri/Galeri.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesGaleri/:id',
    name: 'ProsesGaleri',
    component: () => import('../../components/views/Backoffice/Galeri/ProsesGaleri.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DetailGaleri/:id',
    name: 'DetailGaleri',
    component: () => import('../../components/views/Backoffice/Galeri/DetailGaleri.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarAlbum',
    name: 'DaftarAlbum',
    component: () => import('../../components/views/Publik/DaftarAlbum.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarGaleri/:id',
    name: 'DaftarGaleri',
    component: () => import('../../components/views/Publik/DaftarGaleri.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Dokumen',
    name: 'Dokumen',
    component: () => import('../../components/views/Backoffice/Dokumen/Dokumen.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesDokumen/:id',
    name: 'ProsesDokumen',
    component: () => import('../../components/views/Backoffice/Dokumen/ProsesDokumen.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DetailDokumen/:id',
    name: 'DetailDokumen',
    component: () => import('../../components/views/Backoffice/Dokumen/DetailDokumen.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarAlbumDokumen',
    name: 'DaftarAlbumDokumen',
    component: () => import('../../components/views/Publik/DaftarAlbumDokumen.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarGaleriDokumen/:id',
    name: 'DaftarGaleriDokumen',
    component: () => import('../../components/views/Publik/DaftarGaleriDokumen.vue'),
    meta: {
      transition: "zoom",
    },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  mode: 'history',
  routes: routes,
  linkActiveClass: 'active',
})

export default router;
